<span
  #dropdownTrigger="rtOverlayOrigin"
  rt-overlay-origin
  data-cy="date-range-picker:dropdown-trigger"
>
  <rt-button
    *ngIf="variant === 'button'"
    variant="outlined"
    [dropdownOpened]="state.dropdownOpen"
    [tabIndex]="tabIndex"
    [disabled]="disabled"
    [class.dropdownOpened]="state.dropdownOpen"
    (click)="!disabled && !readOnly && toggleDropdown(true)"
  >
    <div layout layout-align-items-center layout-full-width>
      <rt-icon name="calendar-today"></rt-icon>
      <rt-truncate>{{ selectedValueLabel || placeholder }}</rt-truncate>
    </div>
  </rt-button>

  <rt-input
    *ngIf="variant === 'input'"
    variant="rounded"
    [readOnly]="true"
    [tabIndex]="tabIndex"
    [disabled]="disabled"
    [hasDropdownIndicator]="true"
    [class.dropdownOpened]="state.dropdownOpen"
    [placeholder]="placeholder"
    [value]="selectedValueLabel"
    (click)="!disabled && !readOnly && toggleDropdown(true)"
  >
  </rt-input>

  <rt-button
    *ngIf="variant === 'input-rounded' || variant === 'button-default'"
    variant="secondary"
    [tabIndex]="tabIndex"
    [disabled]="disabled"
    [dropdownOpened]="state.dropdownOpen"
    [class.input-rounded]="variant === 'input-rounded'"
    (click)="!disabled && !readOnly && toggleDropdown(true)"
  >
    <div layout layout-align-items-center layout-full-width>
      <rt-icon name="calendar-today"></rt-icon>
      <rt-truncate>{{ selectedValueLabel || placeholder }}</rt-truncate>
    </div>
  </rt-button>
</span>

<ng-template
  #dropdownOverlay="rtConnectedOverlay"
  rt-connected-overlay
  hasBackdrop
  [origin]="dropdownTrigger"
  [rtConnectedOverlayPosition]="dropdownPosition"
  [open]="state.dropdownOpen"
  (backdropClick)="toggleDropdown(false)"
>
  <rt-dropdown
    (click)="$event.stopPropagation()"
    class="dropdown"
    margin-bottom-small-xx
    [width]="
      state.showCustomDateRangePicker
        ? DropdownWidth.LargeXXXXX
        : horizontalDropdown
        ? DropdownWidth.Large
        : DropdownWidth.SmallX
    "
  >
    <rt-dropdown-header [fullWidthTitle]="!state.showCustomDateRangePicker">
      {{ label || ('app.common.custom_date' | translate) }}
      <rt-icon-button
        *ngIf="state.showCustomDateRangePicker"
        (click)="handleGoBackClick()"
        variant="plain"
        size="small"
        shape="square"
        iconName="arrow-back"
        prefix
      >
      </rt-icon-button>
    </rt-dropdown-header>

    <div
      *ngIf="state.showCustomDateRangePicker"
      [style.width]="'100%'"
      layout-centered
      padding-bottom-small-x
      padding-top-small
    >
      <rt-date-picker
        [mode]="'range'"
        [months]="2"
        [blackout]="blackout"
        [direction]="customRangeDirection"
        [value]="rangeValue"
        (valueChange)="handleCustomDateRangeChange($any($event))"
      >
      </rt-date-picker>
    </div>

    <ng-template [ngIf]="!state.showCustomDateRangePicker">
      <div [class.two-column]="horizontalDropdown">
        <rt-dropdown-item
          *ngFor="let type of possibleDateRanges; trackBy: trackByPossibleDateRange"
          (click)="
            handleDateRangeTypeChange(type);
            type === 'custom' ? $event.stopPropagation() : undefined
          "
          [class.full-width]="type === 'custom' || type === 'all_time' || type === 'range'"
        >
          {{ type | rtDateRangePickerLabel }}
        </rt-dropdown-item>
      </div>
    </ng-template>
    <ng-container *ngIf="addClearOption && value && value.type">
      <rt-dropdown-item (click)="clear()" class="full-width" [noDivider]="true">
        <rt-icon prefix name="clear"></rt-icon>
        {{ 'app.ui.date_range_picker.clear' | translate }}
      </rt-dropdown-item>
    </ng-container>
  </rt-dropdown>
</ng-template>
